// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa1.dev.cmona.de/auto-open-api-spec.yaml 1.9.0
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';
import { VitalSign } from './vitalSign';

export interface PaginatedVitalSignList {
    codes?: Array<string>;
    next?: string | null;
    previous?: string | null;
    results?: Array<VitalSign>;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for PaginatedVitalSignList
 */
export namespace PaginatedVitalSignList {
    /**
     * PaginatedVitalSignList Frontend Model with camelCase properties
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        codes?: Array<string>;
        next?: string | null;
        previous?: string | null;
        @Type(() => VitalSign.Model) results?: Array<VitalSign.Model>;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * PaginatedVitalSignList DTO
     * Transforms PaginatedVitalSignList model from/to API object
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend PaginatedVitalSignList model */
        static toModel(obj: PaginatedVitalSignList): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend PaginatedVitalSignList model */
        static toApi(obj: Model): PaginatedVitalSignList {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as PaginatedVitalSignList;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
